import { Reducer } from 'redux'
import { ActionExternalLinksObjectTypes } from './actions'
import { ExternalLinksState, ExternalLinksActionTypes } from './types'

const initialExternalLinksState: ExternalLinksState = {
  pages: {},
}

export const externalLinksReducer: Reducer<ExternalLinksState, ActionExternalLinksObjectTypes> = (state = initialExternalLinksState, action) => {
  switch (action.type) {
    case ExternalLinksActionTypes.STORE_EXTERNAL_LINKS:
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.payload.idPage]: {
            last: action.payload.result.last,
            page: action.payload.result.page,
            size: action.payload.result.size,
            totalElements: action.payload.result.totalElements,
            totalPages: action.payload.result.totalPages,
            content: [...(state.pages[action.payload.idPage] ? state.pages[action.payload.idPage].content : []), ...action.payload.result.content],
          },
        },
      }
    case ExternalLinksActionTypes.STORE_CLEAR_EXTERNAL_LINKS:
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.payload.idPage]: action.payload.result,
        },
      }
    default:
      return state
  }
}
